import * as React from 'react';

import * as styles from './ServiceItem.css';
import { ICONS } from './customIcons/customIcons';

interface IServiceItemProps {
  icon: keyof typeof ICONS;
  href: string;
  target?: string;
  onClick?(): void;
  children: React.ReactNode;
  dataTestid?: string;
}

export const ServiceItem: React.FC<IServiceItemProps> = ({ icon, href, target, children, dataTestid, onClick }) => {
  const iconElement = ICONS[icon];

  return (
    <li className={styles['container']}>
      <a href={href} target={target} className={styles['item']} onClick={onClick} data-testid={dataTestid}>
        {iconElement}
        {children}
      </a>
    </li>
  );
};
